import { normalizeUser, type User } from '@/data'
import api from '.'

export async function getUser(id: string): Promise<User | null> {
  const res = await api.get(`/${id}`, {
    params: {
      include: 'roles',
    },
  })
  return normalizeUser(res.data.data)
}
